import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NpsCountComponent } from './nps-count.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";



@NgModule({
  declarations: [NpsCountComponent],
  imports: [
    CommonModule,
    HighchartsChartModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [NpsCountComponent]
})
export class NpsCountModule { }
